import { render } from "./producer-update.vue?vue&type=template&id=ea2a42e2"
import script from "./producer-update.vue?vue&type=script&lang=js"
export * from "./producer-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__